import { LocationFilters } from '@hakimo-ui/hakimo/types';
import { FilterItem } from '../location-list/util';
import {
  UPDATE_FILTERS,
  UPDATE_PAGE,
  UPDATE_SEARCH_VALUE,
  UPDATE_SELECTED_FILTER,
  UpdateFiltersAction,
  UpdatePageAction,
  UpdateSearchValueAction,
  UpdateSelectedFilterAction,
} from './actions';

export function createUpdateFiltersAction(
  payload: LocationFilters
): UpdateFiltersAction {
  return {
    type: UPDATE_FILTERS,
    payload,
  };
}

export function createUpdatePageAction(payload: number): UpdatePageAction {
  return {
    type: UPDATE_PAGE,
    payload,
  };
}

export function createUpdateSearchValueAction(
  payload: string
): UpdateSearchValueAction {
  return {
    type: UPDATE_SEARCH_VALUE,
    payload,
  };
}

export function createUpdateSelectedFilterAction(
  payload: FilterItem
): UpdateSelectedFilterAction {
  return {
    type: UPDATE_SELECTED_FILTER,
    payload,
  };
}
